import React, { useEffect, useRef, useState } from 'react'
import BorderHeading from '../../components/heading/BorderHeading';
import ConfigurationHeader from '../../components/heading/ConfigurationHeader';
import { convertValuesToConfig, createValidation, doFinalConfigSubmit, getMetaDataConfig, getNewConfiguration, overWriteConfig, postConfiguration, updateConfiguration } from '../../services/uiConfigService';
import { configurationAttributeType, newConfigurationNames } from '../../types';
import { appValueTypes } from '../../types/types';
import Input from "../../components/Input/Input"
import * as yup from 'yup';
import * as Sentry from "@sentry/react";
import { IndentWrapper } from '../orderConfiguration/OrderConfiguration';
import QuestionHeading from '../../components/heading/QuestionHeading';
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions';
import { openPopup } from '../../stateManagement/actions/popupActions';
import { defaultAppInputValues } from '../defaultConfigurations/appConfigDefaultValues';
import { deepClone } from '@mui/x-data-grid/utils/utils';
import ConfigComparePopup from '../../components/popup/ConfigComparePopup';
import ImportConfig from '../../components/importConfig/ImportConfig';



const SlackAlerts = () => {
    const [appConfig, setAppConfig] = useState<configurationAttributeType[]>([]);
    const [values, setValues] = useState<appValueTypes>(deepClone(defaultAppInputValues))
    const [appValidationsSchema, setAppValidationSchema] = useState({})

    const [showConfigPopup,setShowConfigPopup] = useState<boolean>(false);
    const curConfigRef = useRef<{[key:string]:any[]}>({});
    const newConfigRef = useRef<{[key:string]:any[]}>({});

    const getAppConfiguration = async () => {
        try {
            const resp = await getNewConfiguration('app_configuration');
            const app_config: configurationAttributeType[] = resp?.domainValues;
            curConfigRef.current.app_configuration = deepClone(app_config) ?? [];
            setAppConfig([...app_config])
        } catch (err) {
            // Sentry.captureException(err);
        }
    }
    useEffect(() => {
        getAppConfiguration();
    }, [])

    const saveConfiguration = async (preview?: boolean) => {
            try {
                const resultantValues = { ...values };
                const appSchema = yup.object({ ...appValidationsSchema })
                const validationObject: any = {};
                Object.keys(resultantValues).forEach(key => {
                    validationObject[key] = resultantValues[key].value;
                })
                // await appSchema.validate(validationObject)
                const convertedVals = convertValuesToConfig(resultantValues, appConfig);
                newConfigRef.current.app_configuration = convertedVals??[];
                setShowConfigPopup(true);

            } catch (err) {
                // Sentry.captureException(err);
                console.log("err===", err)
                if (err instanceof Error)
                    openPopup('Error', "Validation Error occured : " + err?.message)
            }
    }

    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: { ...values[keyName], value: e.target.value, isValueUpdated: true }
        })
    }

    const setAppConfigValues = () => {
        try {
            if (appConfig.length) {
                const result = { ...values }
                const resValidations = {} as { [key: string]: ReturnType<typeof createValidation> }
                appConfig.forEach((attr) => {
                    resValidations[attr.name] = createValidation(attr)
                    result[attr.name] = attr;
                })
                setValues({ ...result } as appValueTypes);
                setAppValidationSchema({ ...resValidations })
            }
        } catch (err) {
            // Sentry.captureException(err);

        }
    }

    useEffect(() => {
        setAppConfigValues();
    }, [appConfig])



  const importConfiguration = async (importedConfig:any)=>{
    const newConfigs = await overWriteConfig(importedConfig, {
        app_configuration:['slackAlertChannel']
    })
    newConfigs.forEach((item) => {
        newConfigRef.current[item.domainType] = item.domainValues;
    });
    setShowConfigPopup(true);
  }

  const onConfigComparatorSuccess = async () => {
    await doFinalConfigSubmit("app_configuration",newConfigRef.current.app_configuration,curConfigRef)
    getAppConfiguration();
}

  const [importConfigState,setImportConfigState] = useState(false);


    return (
        <div className='app_configuration_container'>
            <ImportConfig importConfigState={importConfigState} setImportConfigState={setImportConfigState} configNames={['app_configuration']} importConfigCallback={importConfiguration} />
            <ConfigurationHeader heading={"Alerts Configuration"} importConfiguration={()=>{setImportConfigState(true)}} saveConfiguration={() => saveConfiguration(false)} />
            <div className="config_form_container">
                <div className="form_header">
                    <BorderHeading>Slack Alerts</BorderHeading>
                </div>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        slackAlertChannel
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.slackAlertChannel.value} onChange={handleValueChange} name="slackAlertChannel" />
                    </div>
                </IndentWrapper>

            </div>
            <ConfigComparePopup message="Are you sure want to update the config" showConfigPopup={showConfigPopup} setShowConfigPopup={setShowConfigPopup} curConfig={curConfigRef.current} newConfig={newConfigRef.current} onSuccess={onConfigComparatorSuccess } />
        </div>
    )
}

export default SlackAlerts